import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
//import { settings } from "../constants/slider";
const Carousel = ({ settings, children }) => {
  const setting = settings;
  return <Slider {...setting}>{children}</Slider>;
};

export default Carousel;
